/**
 * Grenser for etikettutskrift (TW 36376868).
 *
 * Antall etiketter sendes som `options.copies` på ÉN PrintNode-jobb — antallet
 * koster derfor ingen ekstra jobber. Taket finnes ikke for å spare PrintNode-kvote,
 * men for å hindre to konkrete feil:
 *
 *  1. Skannet strekkode i antallsfeltet. Mottaksskjermene har skannefelt, og lander
 *     fokus i antallsfeltet blir en EAN-13 til `copies: 7032069000128`.
 *  2. Tankeløs masse-utfylling («Linjeantall»/«Sett alle») som brenner en rull etiketter.
 *
 * Taket håndheves også server-side (PrintingLimits.MaxCopiesPerPrintJob) — frontend
 * alene er ikke nok, siden samme endepunkt brukes fra flere skjermer og eksterne kallere.
 * Endres taket her, må det endres der også.
 */
export const MAX_LABELS_PER_PRINT_JOB = 50;

/** Over dette antallet må operatøren bekrefte utskriften. */
export const LABEL_PRINT_CONFIRM_THRESHOLD = 10;

/**
 * Klamper en rå feltverdi til [0, MAX_LABELS_PER_PRINT_JOB].
 * Tom streng beholdes tom — feltet skal kunne tømmes.
 * `clamped` sier om verdien faktisk ble kuttet, slik at kalleren kan vise det
 * for operatøren i stedet for å kutte stille.
 */
export const clampLabelQty = (raw: string): { value: string; clamped: boolean } => {
    const trimmed = raw.trim();
    if (!trimmed) return { value: '', clamped: false };

    const parsed = parseInt(trimmed, 10);
    if (isNaN(parsed) || parsed < 0) return { value: '', clamped: false };
    if (parsed > MAX_LABELS_PER_PRINT_JOB) {
        return { value: String(MAX_LABELS_PER_PRINT_JOB), clamped: true };
    }
    return { value: String(parsed), clamped: false };
};

/** Klamper et tall (f.eks. mottatt antall) til taket. */
export const clampLabelCount = (qty: number): { count: number; clamped: boolean } => {
    const rounded = Math.round(qty);
    if (rounded > MAX_LABELS_PER_PRINT_JOB) {
        return { count: MAX_LABELS_PER_PRINT_JOB, clamped: true };
    }
    return { count: rounded, clamped: false };
};
